import React from 'react';
import {
  Drawer,
  DrawerBody,
  DrawerHeader,
  Typography,
} from '@one-thd/sui-atomic-components';
import { SummaryShipment } from '@src/models/returns';
import PostSelectionItems from '../shared/items/PostSelectionItems';
import LORPExpectList from './lorp-what-to-expect/WhatToExpectList';

interface LorpInstructionsDrawerProps {
  open: boolean;
  onClose: () => void;
  lorpShipments?: SummaryShipment[];
}

const LorpInstructionsDrawer = ({
  open,
  onClose,
  lorpShipments,
}: LorpInstructionsDrawerProps) => {
  const allLorpItems =
    lorpShipments?.flatMap((shipment) => shipment.itemsToReturn) || [];

  return (
    <div className="sui-flex sui-flex-col sui-full sui-gap-4 sui-w-96">
      <Drawer
        open={open}
        onClose={onClose}
        position="right"
        className="drawer-z-index-fix"
      >
        <DrawerHeader title="Return Pickup Instructions" onClose={onClose} />
        <DrawerBody>
          <div className="sui-mb-4">
            <Typography>Return Items</Typography>
          </div>
          <PostSelectionItems selectedReturnItems={allLorpItems} />
          <hr className="sui-mb-4" />
          <LORPExpectList />
        </DrawerBody>
      </Drawer>
    </div>
  );
};

export default LorpInstructionsDrawer;
